document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initPosturas();
  initGaleria();
  initVariantes();
  initMarquesina();
});

function initReveal() {
  var els = document.querySelectorAll('.so-reveal');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('so-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = el.dataset.soDelay || (i * 80);
        setTimeout(function () { el.classList.add('so-visible'); }, delay);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('.so-count[data-target]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.dataset.target) || 0;
      var suffix = el.dataset.suffix || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = (target * eased);
        el.textContent = (target % 1 === 0 ? Math.round(value) : value.toFixed(1)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initPosturas() {
  var wrap = document.querySelector('[data-so-posturas]');
  if (!wrap) return;
  var tabs = wrap.querySelectorAll('[data-so-tab]');
  var panels = wrap.querySelectorAll('[data-so-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var key = tab.getAttribute('data-so-tab');
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var panel = wrap.querySelector('[data-so-panel="' + key + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });
}

function initGaleria() {
  var wrap = document.querySelector('[data-so-galeria]');
  if (!wrap) return;
  var main = wrap.querySelector('[data-so-galeria-principal]');
  var thumbs = wrap.querySelectorAll('[data-so-galeria-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      if (main && full) {
        main.src = full;
        main.alt = alt;
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
}

function initVariantes() {
  var forms = document.querySelectorAll('[data-so-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-so-variantes-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-so-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-so-precio]');
    var compareEl = form.querySelector('[data-so-precio-comparado]');
    var submitBtn = form.querySelector('[data-so-submit]');

    function moneyFmt(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function currentSelection() {
      var vals = [];
      selects.forEach(function (s) { vals.push(s.value); });
      return vals;
    }

    function findVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }

    function update() {
      var variant = findVariant();
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = submitBtn.dataset.textoNoDisponible || 'No disponible'; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = moneyFmt(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = moneyFmt(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.textoDisponible || 'Añadir al carrito';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.dataset.textoAgotado || 'Agotado';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });
}

function initMarquesina() {
  document.querySelectorAll('[data-so-marquesina]').forEach(function (el) {
    var track = el.querySelector('[data-so-marquesina-track]');
    if (!track || track.dataset.soCloned) return;
    track.dataset.soCloned = 'true';
    track.innerHTML += track.innerHTML;
  });
}
